import React from "react";

export default function MapPreview() {
  return (
    <div className="relative h-full min-h-[120px] overflow-hidden rounded-[18px] border border-amber-100 bg-white/80 dark:border-amber-500/10 dark:bg-black/10">
      <div className="absolute inset-0 opacity-70">
        <div className="absolute left-5 top-5 h-[2px] w-28 rotate-6 bg-amber-200 dark:bg-amber-500/20" />
        <div className="absolute left-10 top-12 h-[2px] w-40 -rotate-12 bg-amber-200 dark:bg-amber-500/20" />
        <div className="absolute left-8 top-20 h-[2px] w-32 rotate-3 bg-amber-200 dark:bg-amber-500/20" />
        <div className="absolute right-8 top-9 h-[2px] w-28 -rotate-6 bg-amber-200 dark:bg-amber-500/20" />
        <div className="absolute bottom-10 left-12 h-[2px] w-44 rotate-[8deg] bg-amber-200 dark:bg-amber-500/20" />
      </div>

      <div className="absolute left-10 top-7 h-4 w-4 rounded-full bg-red-500 shadow-lg shadow-red-500/30" />
      <div className="absolute right-16 top-16 h-4 w-4 rounded-full bg-blue-500 shadow-lg shadow-blue-500/30" />
      <div className="absolute bottom-9 left-1/2 h-4 w-4 rounded-full bg-emerald-500 shadow-lg shadow-emerald-500/30" />

      <div className="absolute bottom-4 left-4 rounded-xl bg-white/90 px-3 py-2 text-[11px] font-semibold text-gray-700 backdrop-blur dark:bg-black/30 dark:text-white">
        현장 위치 3곳 감지
      </div>
    </div>
  );
}